var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "table b-table",
        attrs: { items: _vm.items, fields: _vm.fields },
        scopedSlots: _vm._u([
          {
            key: "cell(ver_detalles)",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "ligth" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push(
                          "/verificar-qr-aprobaciones/" + item.ver_detalles
                        )
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "info-circle"] }
                    })
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "cell(estado)",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.fileStates.find(function(s) {
                        return s.id === item.estado
                      }).value
                    )
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }